<div class="flex flex-col h-100-percent" [ngClass]="{'mt-12 ml-24 mr-12 mb-12 contact-us-mat-dialog': data?.matDialog ,'contact-us-dialog': !data?.matDialog }">
  <div class="flex flex-row justify-between">
    <div class="mat-headline-6 mb-4">{{title}}</div>
    <mat-icon svgIcon="close" (click)="data?.matDialog ? matdialogRef.close() : sidenavService.closeRightSidenav()"></mat-icon>
  </div>
  <div *ngIf="!messageSentTry" class="flex-row mb-16">
    <div class="mat-subtitle-2 subtitle-text fw-500">{{'CONTACT_US.WHATEVER_IS_IN_YOUR_MIND' | transloco}}</div>
  </div>

  <!-- validations? -->
  <ng-container *ngIf="!messageSentTry;else sentMessageResult;">
    <form [formGroup]="contactUsForm" class="mb-20">
      <div class="flex-col form-field">
        <label class="mb-6 fs-14 fw-700 mat-headline-6">{{'CONTACT_US.YOUR_MESSAGE' | transloco | uppercase}}</label>
        <textarea class="p-10 text-area-height" placeholder="{{'CONTACT_US.TYPE_MESSAGE' | transloco}}" formControlName="message"
          maxlength="300" required>
        </textarea>
        <div class="flex flex-row justify-between text-width">
          <app-error [control]="contactUsForm.get('message')"></app-error>
          <span class="subtitle-text">{{contactUsForm.get('message').value.length}}/300</span>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-template #sentMessageResult>
    <span @successMessage class="overflow-y-auto" *ngIf="sent;else failureMessage">
      <div class="flex flex-col justify-center items-center message-class-success mb-20 ml-20">
        <div class="green-oval mt-150 mb-20">
          <mat-icon svgIcon="done"></mat-icon>
        </div>
        <div class="mat-headline-5 mb-20">{{'CONTACT_US.MESSAGE_SENT' | transloco}}</div>
        <div class="subtitle-text mb-50">{{'CONTACT_US.WE_WILL_CONTACT_YOU' | transloco}}</div>
        <div class="flex-row" dir="rtl">
          <button type="button" class="white"
          (click)="data?.matDialog ? matdialogRef.close() : sidenavService.closeRightSidenav()">{{'BUTTONS.CLOSE' | transloco}}</button>
        </div>
      </div>
    </span>
    <ng-template #failureMessage>
      <div class="flex flex-col justify-center items-center test overflow-y-auto">
        <div class="red-oval mt-30 mb-20">
          <mat-icon class="cursor-default" svgIcon="close"></mat-icon>
        </div>
        <div class="mat-headline-5 mb-20">{{'CONTACT_US.MESSAGE_NOT_SEND' | transloco}}</div>
        <div class="subtitle-text">{{'CONTACT_US.NOT_SEND_HINT' | transloco}}</div>
        <a href="mailto:bankingcloudsupport@temenos.com" class="mat-subtitle-2">{{'CONTACT_US.SUPPORT_MAIL' | transloco}}</a>
        <div class="flex flex-col mt-20 mb-50 message-class">
          <div class="flex flex-row">
            <label class="mb-4 mat-headline-6">{{'CONTACT_US.YOUR_MESSAGE' | transloco}}</label>
            <img class="ml-20 icon mt-10" (click)="copyText()" src="/assets/images/Vector.svg">
            <div class="mat-subtitle-1 ml-4 mb-0 mt-4" *ngIf="displayTooltip">{{'CONTACT_US.TEXT_COPIED' | transloco}}
            </div>
          </div>
          <textarea id="text-content" class="inner-text-area subtitle-text pt-20 pr-30" [(ngModel)]="typedMessage" readonly="true"></textarea>
        </div>
      </div>
    </ng-template>
  </ng-template>

  <span class="flex-auto"></span>
  <mat-divider class="mb-32"></mat-divider>

  <ng-container *ngIf="!messageSentTry; else showCloseButton">
    <div class="flex flex-row" dir="rtl">
      <button class="ml-16 accent submit-bg-color" type="button" [disabled]="contactUsForm.get('message').value.length === 0 || sendBtnClicked"
        (click)="sendMessage()">{{submit}}</button>
      <button class="white" type="button" (click)="data?.matDialog ? matdialogRef.close() : sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}
      </button>
    </div>
  </ng-container>

  <ng-template #showCloseButton>
  </ng-template>
</div>
